// extracted by mini-css-extract-plugin
export default {"main-wrapper":"ProposedProject_main-wrapper__lj6Rh"};